import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/quests/$uid')({
  beforeLoad: ({ params, search }) => {
    const queryString = new URLSearchParams(
      search as Record<string, string>
    ).toString()

    throw redirect({
      href: `/quests/${params.uid}${queryString ? `?${queryString}` : ''}`,
      replace: true
    })
  }
})
